import { memo } from "react";
import type { ReactNode } from "react";
import { Autocomplete, FormControl, TextField } from "@mui/material";

interface NumeroBonDeCommandeProps {
  numeroBonDeCommande: string | undefined;
  setNumeroBonDeCommande: (numero: string) => void;
  availableNumerosBonDeCommande: Array<string>;
}
const NumeroBonDeCommandeInput = memo(function NumeroBonDeCommandeInput({
  numeroBonDeCommande,
  setNumeroBonDeCommande,
  availableNumerosBonDeCommande = [],
}: Readonly<NumeroBonDeCommandeProps>): ReactNode {
  return (
    <FormControl fullWidth>
      <Autocomplete
        options={availableNumerosBonDeCommande}
        onChange={(_, newValue) => {
          setNumeroBonDeCommande(newValue ?? "");
        }}
        value={numeroBonDeCommande ?? null}
        renderInput={(params) => (
          <TextField {...params} label="N° Bon de commande" placeholder="4500037812MAG" />
        )}
        size="small"
      />
    </FormControl>
  );
});

export default NumeroBonDeCommandeInput;
